import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-view-image-modal',
  templateUrl: './view-image-modal.component.html',
  styleUrls: ['./view-image-modal.component.css'],
})
export class ViewImageModalComponent {
  @Input() headerText: string;
  @Input() imagePath: string;
  @Input() buttonText = 'Close';

  constructor(private ngbActiveModal: NgbActiveModal) {}

  closeModal() {
    this.ngbActiveModal.close();
  }
}
